<template>
  <div id="RulesOfRegulationPage">
    <NavBar/>
    <v-main class="third-bg">
      <div class="container-fluid container-md py-10">
        <div class="row">
          <div class="col-12 text-center">
            <h1>
              <span class="font-19 border-bottom-gold px-5">قوانین و مقررات</span>
            </h1>
            <div class="text-center px-5">
              <v-img :src="$replaceHttps(fileUrl)"></v-img>
              <div class="mt-4 font-16" v-html="descriptions"></div>
              <a class="mt-3" v-if="link !== null" :href="link" target="_blank">
                <v-btn color="primary">مشاهده لینک </v-btn>
              </a>
              <!--                                <div class="mt-4">شماره دفتر مرکزی: {{officePhone}}</div>-->
              <!--                                <div class="mt-4">آدرس دفتر مرکزی:</div>-->
              <!--                                <div class="mt-3">{{officeAddress}}</div>-->
            </div>
          </div>
        </div>

      </div>
    </v-main>
    <FooterComponent/>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "RulesOfRegulation",
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {FooterComponent, NavBar},
  data: () => ({
    showLoaderDialog: false,
    descriptions: '',
    fileUrl: '',
    link: null
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetPage?typePage=3", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.descriptions = json.Description
            this.fileUrl = json.FileUrl
            this.link = json.Link
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    }
  }

}
</script>
